import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RegionListLayer from "../components/RegionListLayer";

const RegionListPage = () => {
    return (
        <MasterLayout>
            <RegionListLayer />
        </MasterLayout>
    );
};

export default RegionListPage;
